__turbopack_context__.v({
  "bottom": "-gxOHG_bottom",
  "securityDesktop": "-gxOHG_securityDesktop",
  "securityDesktopnoPadding": "-gxOHG_securityDesktopnoPadding",
  "securityXs": "-gxOHG_securityXs",
  "sm": "-gxOHG_sm",
  "sm2": "-gxOHG_sm2",
  "smLink": "-gxOHG_smLink",
  "smLink2": "-gxOHG_smLink2",
  "soc": "-gxOHG_soc",
  "soc2": "-gxOHG_soc2",
  "socLink": "-gxOHG_socLink",
  "socLink2": "-gxOHG_socLink2",
  "ssl": "-gxOHG_ssl",
  "ssl2": "-gxOHG_ssl2",
  "sslLink": "-gxOHG_sslLink",
  "sslLink2": "-gxOHG_sslLink2",
  "top": "-gxOHG_top",
  "truste": "-gxOHG_truste",
  "truste2": "-gxOHG_truste2",
  "trusteLink": "-gxOHG_trusteLink",
  "trusteLink2": "-gxOHG_trusteLink2",
  "wrapper": "-gxOHG_wrapper",
});
